import { getFields, getFormFields } from './getFields'

import { BoolFieldClass, ButtonFieldClass, ColorFieldClass, DataFieldClass, DateFieldClass, PeriodFieldClass, EmailFieldClass, EmptyFieldClass, FloatFieldClass, HiddenFieldClass, ImageListFieldClass, IntFieldClass, ListFieldClass, StringFieldClass, TextFieldClass, TinymceFieldClass, WidgetFieldClass } from '@/models'
import { BaseFieldClass } from '@/models/fields/baseField.class'
import { FileListFieldClass } from '@/models/fields/fileListField.class'
import { Layout } from '@/models/layout/layout.class'
import { SectionClass, SectionsClass } from '@/models/sections/sections.class'
import { IServerField } from '@/types/serverField.type'

export {
  getFields,
  getFormFields,
  SectionClass,
  SectionsClass,
  Layout
}

// Новая функция инициализации полей
export function createField (field: IServerField): BaseFieldClass {
  switch (field.Type) {
    case 'string': return new StringFieldClass(field)
    case 'text': return new TextFieldClass(field)
    case 'password': return new TextFieldClass(field)
    case 'bool': return new BoolFieldClass(field)
    case 'date': return new DateFieldClass(field)
    case 'period': return new PeriodFieldClass(field)
    case 'listInt': return new ListFieldClass(field)
    case 'list': return new ListFieldClass(field)
    case 'Widget': return new WidgetFieldClass(field)
    case 'int': return new IntFieldClass(field)
    case 'float': return new FloatFieldClass(field)
    case 'hidden': return new HiddenFieldClass(field)
    case 'color': return new ColorFieldClass(field)
    case 'email': return new EmailFieldClass(field)
    case 'tinyMCE': return new TinymceFieldClass(field)
    case 'imageList': return new ImageListFieldClass(field)
    case 'fileList': return new FileListFieldClass(field)
    case 'data': return new DataFieldClass(field)
    case 'empty': return new EmptyFieldClass(field)
    case 'button': return new ButtonFieldClass(field)
    default:
      console.error(`Неизвестный тип поля: ${(field as any).Type}`)
      return new HiddenFieldClass(field as any)
  }
}

interface FieldClassConstructor {
  new(field: IServerField): BaseFieldClass
  (field: IServerField): BaseFieldClass
  prototype: BaseFieldClass
}

function FieldClassFactory (field: IServerField): BaseFieldClass {
  return createField(field)
}

FieldClassFactory.prototype = BaseFieldClass.prototype

export const FieldClass = FieldClassFactory as unknown as FieldClassConstructor
export type FieldClass = BaseFieldClass

interface IExportConfigOption {
  icon: string
  name: string
  title: string
}

export class ExportConfig {
  exportUrl: string = ''
  options: IExportConfigOption[] = []

  constructor (data?: { exportUrl: string, options: IExportConfigOption[] }) {
    if (data) {
      this.exportUrl = data.exportUrl
      this.options = data.options
    }
  }
}
